


@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 animate-fade-in-fast backdrop-blur-sm">
    <div class="bg-slate-800 rounded-xl shadow-2xl w-full max-w-md p-6 border border-slate-700 m-4">
      <div class="flex items-start gap-4">
        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-slate-700">
          <i class="fa-solid fa-triangle-exclamation text-2xl text-yellow-400"></i>
        </div>
        <div class="flex-grow">
          <h2 class="text-xl font-bold text-white">{{ title() }}</h2>
          <p class="text-slate-300 mt-2">
            {{ message() }}
          </p>
        </div>
      </div>
      
      <div class="mt-8 flex justify-end space-x-3">
        <button type="button" (click)="onCancel()" class="bg-slate-600 text-white px-5 py-2.5 rounded-md hover:bg-slate-500 font-semibold transition-colors">
          {{ cancelButtonText() | translate }}
        </button>
        <button 
          type="button" 
          (click)="onConfirm()" 
          [class]="'text-white px-5 py-2.5 rounded-md font-semibold transition-colors ' + confirmButtonClass()">
          {{ confirmButtonText() }}
        </button>
      </div>
    </div>
  </div>
}